import * as constants from '../constants';

export const requestSurveyTrackers = (
    surveyId,
    waveId,
    offset,
    limit,
    sortBy,
    filter,
    filterText,
) => ({
    type: constants.SURVEY_TRACKERS_REQUESTED,
    payload: {surveyId, waveId, offset, limit, sortBy, filter, filterText},
});
export const surveyTrackersSuccess = (data) => ({type: constants.SURVEY_TRACKERS_SUCCESS, payload: {data}});
export const surveyTrackersFailure = (error) => ({type: constants.SURVEY_TRACKERS_FAILURE, payload: {error}});

export const requestSurveyTrackersSend = (surveyId, waveId, data) => ({type: constants.SURVEY_TRACKERS_SEND_REQUESTED, payload: {surveyId, waveId, data}});
export const surveyTrackersSendSuccess = (data) => ({type: constants.SURVEY_TRACKERS_SEND_SUCCESS, payload: {data}});
export const surveyTrackersSendFailure = (error) => ({type: constants.SURVEY_TRACKERS_SEND_FAILURE, payload: {error}});

export const requestSurveyTrackerDelete = (surveyId, waveId, trackerId) =>
    ({type: constants.SURVEY_TRACKERS_DELETE_REQUESTED, payload: {surveyId, waveId, trackerId}});
export const surveyTrackerDeleteSuccess = (data) => ({type: constants.SURVEY_TRACKERS_DELETE_SUCCESS, payload: {data}});
export const surveyTrackerDeleteFailure = (error) => ({type: constants.SURVEY_TRACKERS_DELETE_FAILURE, payload: {error}});

export const requestSurveyTrackersSave = (surveyId, waveId, data) => ({type: constants.SURVEY_TRACKERS_SAVE_REQUESTED, payload: {surveyId, waveId, data}});
export const surveyTrackersSaveSuccess = (data) => ({type: constants.SURVEY_TRACKERS_SAVE_SUCCESS, payload: {data}});
export const surveyTrackersSaveFailure = (error) => ({type: constants.SURVEY_TRACKERS_SAVE_FAILURE, payload: {error}});

export const requestSurveyTrackersTest = (surveyId, waveId, data) => ({type: constants.SURVEY_TRACKERS_TEST_REQUESTED, payload: {surveyId, waveId, data}});
export const surveyTrackersTestSuccess = (data) => ({type: constants.SURVEY_TRACKERS_TEST_SUCCESS, payload: {data}});
export const surveyTrackersTestFailure = (error) => ({type: constants.SURVEY_TRACKERS_TEST_FAILURE, payload: {error}});

export const requestSurveyTrackersDelete = (surveyId, waveId) =>
    ({type: constants.SURVEY_WAVE_TRACKERS_DELETE_REQUESTED, payload: {surveyId, waveId}});
export const surveyTrackersDeleteSuccess = (data) => ({type: constants.SURVEY_WAVE_TRACKERS_DELETE_SUCCESS, payload: {data}});
export const surveyTrackersDeleteFailure = (error) => ({type: constants.SURVEY_WAVE_TRACKERS_DELETE_FAILURE, payload: {error}});

export const requestSurveyTrackersArchiveUpdate = (id, trackerArchiveFrequency, trackerArchiveFrequencyValue) => ({
    type: constants.SURVEY_TRACKERS_ARCHIVE_UPDATE_REQUESTED,
    payload: {id, trackerArchiveFrequency, trackerArchiveFrequencyValue},
});
export const surveyTrackersArchiveUpdateSuccess = (data) => ({type: constants.SURVEY_TRACKERS_ARCHIVE_UPDATE_SUCCESS, payload: {data}});
export const surveyTrackersArchiveUpdateFailure = (error) => ({type: constants.SURVEY_TRACKERS_ARCHIVE_UPDATE_FAILURE, payload: {error}});
